import * as ActionTypes from './EnumTypes/ActionEnumTypes';
import * as NotificationActionModel from './Models/NotificationActionModel';
import * as NotificationModule from 'Modules/NotificationModule';

function readNotification(notificationId: number) {
    return async dispatch => {
        try {
            dispatch(readNotificationSuccess(notificationId));
            await NotificationModule.Connector.readNotification({ notificationIds: [notificationId] });
        } catch (err) {
            //
        }
    };
}
function openSSENotification(token:string) {
    return async dispatch => {
        try {
            const webSocket: EventSource = NotificationModule.Connector.openNotificationWSS(token);
            webSocket.addEventListener('notification', (message: MessageEvent) => {
                if (message.data) {
                    dispatch(addNewNotification(JSON.parse(message.data)));
                }
            });
            webSocket.onopen = () => {
                dispatch(openSSENotificationSuccess());
            };
            webSocket.onerror = err => {
                // console.log('error: ' + Object.keys(message), message.isTrusted);
            };
        } catch (err) {
            //
        }
    };
}
function addNewNotification(newNotification: NotificationModule.Types.NotificationDto): NotificationActionModel.AddNewNotification {
    return {
        type: ActionTypes.NOTIFICATION.ADD_NEW_NOTIFICATION,
        payload: {
            newNotification
        }
    };
}
function openSSENotificationSuccess() {
    return {
        type: ActionTypes.NOTIFICATION.OPEN_SSE_NOTIFICATION
    };
}
function updateParams(): NotificationActionModel.UpdateParams {
    return {
        type: ActionTypes.NOTIFICATION.UPDATE_PARAMS
    };
}
function setActiveNotification(notification: NotificationModule.Types.NotificationDto): NotificationActionModel.SetActiveNotification {
    return {
        type: ActionTypes.NOTIFICATION.SET_ACTIVE_NOTIFICATION,
        payload: {
            notification
        }
    };
}
function getNotifications(params?: URLSearchParams) {
    return async dispatch => {
        try {
            const results = await NotificationModule.Connector.getNotifications(params);
            dispatch(getNotificationsSuccess(results.data));
        } catch (err) {
            //
        }
    };
}
function readNotificationSuccess(notificationId: number): NotificationActionModel.ReadNotification {
    return {
        type: ActionTypes.NOTIFICATION.READ_NOTIFICATION,
        payload: {
            notificationId
        }
    };
}

function getNotificationsSuccess(notifications: NotificationModule.Types.GetNotificationsResponse): NotificationActionModel.GetNotifications {
    return {
        type: ActionTypes.NOTIFICATION.GET_NOTIFICATIONS,
        payload: {
            notifications
        }
    };
}

function clearNotificationsActionCreator(): NotificationActionModel.ClearNotifications {
  return {
    type: ActionTypes.NOTIFICATION.CLEAR_NOTIFICATIONS
  }
}

function clearNotifications() {
    return async (dispatch) => {
      try {
        await NotificationModule.Connector.readNotification();
        dispatch(clearNotificationsActionCreator());
      } catch (e) {
        // nic nie rób
      }
    }
}

export {
  getNotifications,
  readNotification,
  openSSENotification,
  updateParams,
  setActiveNotification,
  clearNotifications,
};



// WEBPACK FOOTER //
// ./src/Redux/Actions/NotificationActions.ts